// base
import React from 'react';

// style
import { StyledBasicModal } from './style';

// libraries
import { Modal } from '@mui/material';
import { TextButton } from 'components/Buttons';

export interface BasicModalProps {
  open: boolean;
  onClose: () => void;
  width?: number;
  height?: number;
  header?: string;
  body: React.ReactNode;
  footer?: React.ReactNode;
}

export const BasicModal: React.FC<BasicModalProps> = ({
  open,
  onClose,
  header,
  body,
  footer,
  width = 400,
  height = 200
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <StyledBasicModal width={width} height={height} useFooter={!!footer}>
        {header && (
          <div className="modalHead">
            {header}
            <TextButton variant="text" className="close" label={''} onClick={onClose} />
          </div>
        )}
        <div className="modalBody">{body}</div>
        {footer && <div className="modalFoot">{footer}</div>}
      </StyledBasicModal>
    </Modal>
  );
};
